export enum NavLabels {
  Logout = 'menu.title.logout',
  Courses = 'menu.title.courses',
  Overview = 'menu.title.overview',
  Certificates = 'menu.title.certificates',
}

export enum NavRoutes {
  QUIZ = '/quiz',
  COURSES = '/courses',
  OVERVIEW = '/overview',
  CERTIFICATES = '/certificates',
}
